/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useAppContext } from '../contexts/auth';
interface UploadDocPayload {
  key: string;
  value: string | File | null | number | boolean | undefined;
}

interface ApiToCallInterface {
  reqBody?: string | UploadDocPayload[] | null,
  token: string,
}

interface ApiCallInterface {
  onStartLoad?: () => void,
  onEndLoad?: () => void,
  apiToCall: ({ token, reqBody }: ApiToCallInterface) => Promise<any>,
  reqBody?: string | UploadDocPayload[] | null,
  catchMessage?: string;
  catchAction?: () => void;
  actionAfterResponse: ((response: any) => void) | ((response: any) => Promise<void>);
  queryParams?: { [key: string]: string | boolean | number | undefined | Date },
  isValidationToken?: boolean,
  isFirstTokenAPi?: boolean,
  validationToken?: string,
  isLoginApi?: boolean,
}

export default function useApiCall() {
  type AppContextType = {
    token: string;
    validationTk: string;
    signOut: () => void;
  }

  const { token, signOut, validationTk }: AppContextType = useAppContext();

  const apiCall = useCallback(async ({
    onStartLoad,
    onEndLoad,
    apiToCall,
    reqBody,
    queryParams,
    catchMessage,
    actionAfterResponse,
    catchAction,
    isValidationToken = false,
    isFirstTokenAPi = false,
    isLoginApi = false,
    validationToken = '',
  }: ApiCallInterface) => {
    try {
      if (onStartLoad) {
        onStartLoad();
      }
      const tokenToBeCalled = !isValidationToken ? token : (isLoginApi ? validationToken : validationTk);
      const mergedParams = {
        token: tokenToBeCalled,
        reqBody,
        ...(queryParams ?? {}),
      };

      const apiResponse = await apiToCall(mergedParams);
      if (apiResponse === 'unauthorized' && isValidationToken && !isFirstTokenAPi) {
        toast.error('Sua sessão expirou. Por favor, recarregue a página', { toastId: 'session-expired' });
        return;
      }
      if (apiResponse === 'unauthorized' && !isValidationToken && !isFirstTokenAPi) {
        signOut();
        return;
      }
      await actionAfterResponse(apiResponse);

      return apiResponse;
    } catch (error) {
      if (catchAction) {
        catchAction();
      }
      if (catchMessage) {
        toast.error(`${catchMessage} (${error})`);
        return;
      }
      toast.error(`Não foi possível concluir a solicitação. (${error})`);
      return;
    } finally {
      if (onEndLoad) {
        onEndLoad();
      }
    }
  }, [signOut, token, validationTk]);

  return { apiCall };
}
